import React from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';
import { RIGHT } from 'services/enums/sides';

const ActionButtons = ({
  cancel,
  locked,
  remove,
  save,
  saveButtonText,
}: {
  cancel: () => void;
  locked: boolean;
  remove?: () => void | undefined;
  save: () => void;
  saveButtonText: string;
}): JSX.Element => {
  const { t } = useTranslation([translations.common]);

  const offerIsLocked = () => locked;

  return (
    <>
      <PrimaryButton className="button-one-line" float={RIGHT} onClick={cancel}>
        {t(`${translations.common}:Cancel`).toLocaleUpperCase()}
      </PrimaryButton>
      {remove === undefined || offerIsLocked() ? null : (
        <PrimaryButton
          className="button-one-line"
          float={RIGHT}
          onClick={remove}
        >
          {t(`${translations.common}:Remove`).toLocaleUpperCase()}
        </PrimaryButton>
      )}
      {offerIsLocked() ? null : (
        <PrimaryButton className="button-one-line" float={RIGHT} onClick={save}>
          {saveButtonText.toLocaleUpperCase()}
        </PrimaryButton>
      )}
      <div className="clearfix" />
    </>
  );
};

export default ActionButtons;
